<template>
  <div class="products">

    <div id="our-software" class="our-software"></div>

    <!-- TITLE -->
    <h1 class="product-heading">our software</h1>

    <!-- SVG BLOB SHAPE -->
    <Blob></Blob>

    <div class="product-block">

      <div class="product-block-text product-block-element-left">

        <!-- HEADING OF PRODUCT DETAIL -->
        <div class="product-title">MikMak Attach</div>
        <div class="patent-badge">Patent Pending</div>
        <div class="product-subtitle">Attach makes your media shoppable. It lives after "the click" or "swipe up" in digital and social channels.</div>
        <!--  -->
      </div>

      <StepUseAttachAnywhere></StepUseAttachAnywhere>
      <StepVerticalValueProps></StepVerticalValueProps>
      <StepAmazonValueProps></StepAmazonValueProps>
      <StepOwnYourAudience></StepOwnYourAudience>
    </div>

  </div>
</template>

<script>

import LOGOS from './logos'

import StepUseAttachAnywhere from './components/StepUseAttachAnywhere'
import StepOwnYourAudience from './components/StepOwnYourAudience'
import StepAmazonValueProps from './components/StepAmazonValueProps'
import StepVerticalValueProps from './components/StepVerticalValueProps'

import Blob from './blob'

export default {
  data() {
    return {
      videoSrc: '',
      socialLogos: LOGOS.social,
      commerceLogos: LOGOS.commerce
    }
  },
  components: {
    Blob,
    StepUseAttachAnywhere,
    StepOwnYourAudience,
    StepAmazonValueProps,
    StepVerticalValueProps
  },
  mounted() {
    if (!window.sr) window.sr = ScrollReveal()
    window.sr.reveal('.products', { delay: 250, duration: 500 })
  },
  methods: {
    getSocialImageUrl(name) {
      var images = require.context('../../../assets/social-logos/')
      return images(`./${name}.png`)
    },
    getWinterImage(name) {
      var images = require.context('../../../assets/winter-2019/')
      return images(`./${name}.png`)
    },
    getVideoUrl(name) {
      return `https://s3.amazonaws.com/attach-videos/${name}`
    }
  },
  computed: {},
  watch: {}
}
</script>

<style scoped>

  .our-software {
    height: 80px;
  }

  .products {
    display: block;
    overflow: hidden;
    margin-bottom: 0px;
  }

  .product-heading {
    font-family: "Work Sans",sans-serif;
    font-weight: normal;
    letter-spacing: 2px;
    font-size: 14px;
    margin: 0 auto;
    display: block;
    text-align: center;
    color: #333;
    background: linear-gradient(135deg, #24af94 0%,#31c4a8 69%,#19d09d 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-transform: uppercase;
    position: relative;
    width: 100%;
  }

  .product-block {
    font-family: "Vaud", -apple-system, BlinkMacSystemFont, "Avenir Next", "Avenir", "Segoe UI", "Lucida Grande", "Helvetica Neue", "Helvetica", "Fira Sans", "Roboto", "Noto", "Droid Sans", "Cantarell", "Oxygen", "Ubuntu", "Franklin Gothic Medium", "Century Gothic", "Liberation Sans", sans-serif;
    margin: 0 auto;
    min-height: 420px;
    display: block;
  }

  .product-block-text {
    display: block;
    width: 100%;
    max-width: 600px;
    text-align: center;
    margin: 24px auto;
  }

  @media only screen and (max-width: 800px) {

    .product-block-text {
      max-width: 80%;
    }
  }

  .product-title {
    font-family: 'Raleway', sans-serif;
    font-size: 32px;
    color: #333;
  }

  .product-subtitle {
    font-family: "Work Sans", sans-serif;
    font-size: 18px;
    color: #5a5959;
    margin: 12px auto;
  }

  .blob-two {
    transform: scale(5) rotate(131deg) !important;
    margin-top: 0px !important;
    margin-left: 250px;
  }

  .patent-badge {
    display: block;
    background: #19d09d;
    width: 165px;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: white;
    margin: 8px auto;
    border-radius: 2px;
    font-weight: lighter;
    padding: 2px;
  }

</style>



// WEBPACK FOOTER //
// MikMakAttach.vue?d5983cf4